"use strict";

exports.__esModule = true;
exports.TabsWrapper = void 0;
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TabsWrapper = exports.TabsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__TabsWrapper",
  componentId: "sc-10p4iuh-0"
})(["overflow:hidden;.", "{height:", "px;width:", "px;.", "{padding:0 1rem;flex-wrap:wrap;height:auto;.", "{outline:none;}}&.", " .", "{padding:3px 0;flex-wrap:nowrap;overflow-y:auto;}}"], _core.Classes.TABS, function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, _core.Classes.TAB_LIST, _core.Classes.TAB, _core.Classes.VERTICAL, _core.Classes.TAB_LIST);